import apiClient from './api/apiClient';

interface AuthResponse {
  status: {
    success: boolean;
    errorMessage?: string;
    reason?: string;
  };
  data?: {
    jwt_auth?: string;
  };
}

export const sendOTP = async (email: string, orgId: string): Promise<AuthResponse> => {
  try {
    const response = await apiClient.post(`/auth/sendOTP`, { email, organization_id: orgId });
    return response.data;
  } catch (error: any) {
    if (error.response?.data) {
      return error.response.data;
    }
    return {
      status: {
        success: false,
        errorMessage: 'Network error occurred',
        reason: 'NETWORK_ERROR'
      }
    };
  }
};

export const verifyOTP = async (email: string, otp: string): Promise<AuthResponse> => {
  try {
    const response = await apiClient.post(`/auth/verifyOTP`, { email, otp });
    return response.data;
  } catch (error: any) {
    if (error.response?.data) {
      return error.response.data;
    }
    return {
      status: {
        success: false,
        errorMessage: 'Network error occurred',
        reason: 'NETWORK_ERROR'
      }
    };
  }
};

export const saveAuthToken = (token: string): void => {
  localStorage.setItem('auth_token', token);
};

export const getAuthToken = (): string | null => {
  return localStorage.getItem('auth_token');
};

export const removeAuthToken = (): void => {
  localStorage.removeItem('auth_token');
};

export const isAuthenticated = (): boolean => {
  return !!getAuthToken();
};
